export default "__VITE_ASSET__DVF9P0Q0__"